import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { get, isFunction } from 'lodash';
import { Query } from 'react-apollo';
import { compose, setDisplayName } from 'recompose';

import UserChangedWarningModal from './UserChangedWarningModal';
import caseAssignedToQuery from './caseAssignedToQuery';

const watchForOwnerChanges =
  process.env.REACT_APP_ENABLE_CASE_OWNERSHIP_CHANGE_WATCHER === 'true';

const withCaseOwnerQuery = WrappedComponent => componentProps => {
  const { caseNumber } = componentProps;

  return (
    <Query
      fetchPolicy="network-only"
      query={caseAssignedToQuery}
      variables={{ caseNumber }}
      skip={!caseNumber}
    >
      {({ data, loading, startPolling }) => {
        const currentUser = get(data, 'currentUserProfile.user', {});
        const caseAssignedTo = get(data, 'case.assignedTo', {});

        return (
          <WrappedComponent
            {...componentProps}
            ownerLoading={loading}
            currentUser={currentUser}
            caseAssignedTo={caseAssignedTo}
            startPollingForCaseOwner={startPolling}
          />
        );
      }}
    </Query>
  );
};

class WatchForOwnerChange extends Component {
  static propTypes = {
    caseNumber: PropTypes.string.isRequired,
    ownerLoading: PropTypes.bool.isRequired,
    currentUser: PropTypes.shape({
      email: PropTypes.string,
    }),
    caseAssignedTo: PropTypes.shape({
      email: PropTypes.string,
    }),
    startPollingForCaseOwner: PropTypes.func.isRequired,
    children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
  };

  static defaultProps = {
    currentUser: null,
    caseAssignedTo: null,
    children: undefined,
  };

  state = {
    showModal: false,
  };

  componentDidMount() {
    this.startPollingTimeout = setTimeout(this.startPolling, 7500);
  }

  componentDidUpdate(prevProps) {
    if (this.props.ownerLoading) {
      // do nothing while the case is loading
      return;
    }

    // show the modal if the assigned user on the case changed from
    // me to some other user...

    const prevAssignedEmail = get(prevProps.caseAssignedTo, 'email');
    const nowAssignedEmail = this.getCaseAssignedEmail();
    const currentUserEmail = this.getCurrentUserEmail();

    if (
      prevAssignedEmail === currentUserEmail &&
      prevAssignedEmail !== nowAssignedEmail &&
      nowAssignedEmail !== currentUserEmail &&
      !this.state.showModal
    ) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ showModal: true });
    }
  }

  componentWillUnmount() {
    if (this.startPollingTimeout) {
      clearTimeout(this.startPollingTimeout);
      this.startPollingTimeout = null;
    }
  }

  getCurrentUserEmail = () => get(this.props.currentUser, 'email');

  getCaseAssignedEmail = () => get(this.props.caseAssignedTo, 'email');

  startPollingTimeout = null;

  closeModal = () => this.setState({ showModal: false });

  startPolling = () => {
    if (!watchForOwnerChanges) {
      return;
    }

    this.startPollingTimeout = null;
    this.props.startPollingForCaseOwner(2000);
  };

  render() {
    const { caseNumber, caseAssignedTo, children } = this.props;

    return (
      <Fragment>
        {isFunction(children) ? children({ caseAssignedTo }) : children}
        {this.state.showModal && (
          <UserChangedWarningModal
            onClose={this.closeModal}
            caseIsAssigned={!!this.getCaseAssignedEmail()}
            caseNumber={caseNumber}
          />
        )}
      </Fragment>
    );
  }
}

export default compose(
  setDisplayName('WatchForOwnerChange'),
  withCaseOwnerQuery,
)(WatchForOwnerChange);



// WEBPACK FOOTER //
// ./src/compositions/CaseOwnershipCheck/WatchForOwnerChange.js